// Opens the product gallery images in a Fancybox lightbox with zoom, pan and thumbnails.
// Loaded by the product section when its "Image behavior" setting is set to 'lightbox'.

// Fancybox zooms to the file's own pixel size, so a small photo ends up with no usable
// zoom at all. These let every photo zoom by a consistent amount: ZOOM_FACTOR times the
// size it is shown at, but never enlarging a file more than MAX_UPSCALE beyond its own
// pixels, which keeps the softness of low-resolution photos within reason.
const ZOOM_FACTOR = 2.5;
const MAX_UPSCALE = 2;

document.addEventListener(
  'click',
  (event) => {
    const toggle = event.target.closest('.product__media-toggle[data-zoom-src]');
    if (!toggle || !window.jQuery || !window.jQuery.fancybox) return;

    // Handled in the capture phase so <modal-opener> never opens the stacked media modal.
    event.preventDefault();
    event.stopPropagation();

    // Scoped to the clicked gallery: the section renders a second, duplicated gallery
    // when the media position is 'right', and both are in the DOM at the same time.
    const gallery = toggle.closest('media-gallery') || document;
    const toggles = Array.from(gallery.querySelectorAll('.product__media-toggle[data-zoom-src]')).filter(
      (element) => element.offsetParent !== null
    );

    window.jQuery.fancybox.open(
      toggles.map((element) => ({
        src: element.dataset.zoomSrc,
        thumb: element.dataset.zoomThumb,
        type: 'image',
      })),
      {
        buttons: ['zoom', 'thumbs', 'close'],
        thumbs: { autoStart: false },
        loop: true,
        afterLoad: (instance, slide) => {
          if (slide.type !== 'image' || !slide.width) return;
          const target = Math.min(instance.getFitPos(slide).width * ZOOM_FACTOR, slide.width * MAX_UPSCALE);
          if (target <= slide.width) return;
          slide.height = Math.round(slide.height * (target / slide.width));
          slide.width = Math.round(target);
        },
      },
      toggles.indexOf(toggle)
    );
  },
  true
);
